const AFTERSHIP_WIDGET_STYLES = `
  #widgetHeaderContainer {
    margin-inline: -40px 0 !important;
    margin-bottom: 32px !important;
  }

  #leftOverallRatingCurrentRate {
    color: var(--color-text-primary) !important;
    font-family: Geograph, Helvetica, Arial, sans-serif !important;
    font-size: 32px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    letter-spacing: 0.5px !important;
    line-height: 22px !important;
  }

  #starGroupContainer {
    gap: 5px !important;
    margin-right: 2px !important;
  }

  #writeReviewButton {
    align-items: center !important;
    border-radius: 0 !important;
    display: flex !important;
    flex: 0 1 auto !important;
    font-family: Geograph, Helvetica, Arial, sans-serif !important;
    font-size: 11px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    gap: 24px !important;
    justify-content: center !important;
    letter-spacing: 2px !important;
    line-height: 140% !important;
    padding: 10px 12px 10px 15px !important;
    text-transform: uppercase !important;
    width: auto !important;
  }

  #writeReviewButton::after {
    background: repeat center / contain url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='white' fill-rule='evenodd' clip-rule='evenodd' d='M16 6.116 21.884 12 16 17.884 15.116 17l4.375-4.375H2.375v-1.25h17.116L15.116 7 16 6.116Z'/></svg>") !important;
    color: #fff !important;
    content: '' !important;
    display: inline-block !important;
    height: 24px !important;
    width: 24px !important;
  }

  .solid-select-control {
    border: 0 !important;
    gap: 11px !important;
    min-height: unset !important;
    padding: 0 !important;
  }

  .solid-select-input {
    border: 0 !important;
    height: 8px !important;
    padding: 0 !important;
  }

  .solid-select-single-value {
    font-family: Geograph, Helvetica, Arial, sans-serif !important;
    font-size: 8px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    letter-spacing: 2px !important;
    line-height: 140% !important;
    text-transform: uppercase !important;
  }

  [class^="aftership-reviews-widget-v2_sort"] {
    height: 0 !important;
    margin: 0 !important;
    visibility: hidden !important;
  }

  [class^="aftership-reviews-widget-v2_title"] {
    color: var(--color-text-primary) !important;
    font-family: Geograph, Helvetica, Arial, sans-serif !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    letter-spacing: 0.5px !important;
    line-height: 140% !important;
    margin-bottom: 37px !important;
    text-transform: uppercase !important;
  }

  [class^="aftership-reviews-widget-v2_leftOverallRating"] {
    margin-block: 0 !important;
  }

  [class^="aftership-reviews-widget-v2_ratingReviewsContainer"] {
    gap: 5px !important;
    margin-block: 0 !important;
  }

  [class^="aftership-reviews-widget-v2_ratersContainer"] {
    display: flex !important;
    flex-direction: column !important;
    gap: 5px !important;
  }

  [class^="aftership-reviews-widget-v2_maxRate"] {
    color: var(--color-text-secondary) !important;
    font-family: Geograph, Helvetica, Arial, sans-serif !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    letter-spacing: 0.5px !important;
    line-height: 100% !important;
    opacity: 1 !important;
  }

  [class^="aftership-reviews-widget-v2_rate--"] {
    margin-bottom: 16px !important;
  }

  [class^="aftership-reviews-widget-v2_filterSortContainer"] {
    border-bottom: 1px solid var(--color-border-secondary) !important;
    padding: 16px 24px !important;
  }

  [class^="aftership-reviews-widget-v2_cardContainer"] {
    border-bottom: 0 !important;
    margin-top: 56px !important;
    padding: 0 !important;
  }

  [class^="aftership-reviews-widget-v2_cardContainer"] div:nth-child(1) > div:nth-child(2) {
    color: var(--color-text-secondary) !important;
    font-family: Geograph, Helvetica, Arial, sans-serif !important;
    font-size: 13px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    letter-spacing: 0.25px !important;
    line-height: 140% !important;
    margin-top: 0 !important;
    position: relative !important;
    top: 42px !important;
  }

  [class^="aftership-reviews-widget-v2_cardContainer"] > div:nth-child(2) {
    margin-top: 16px !important;
  }

  [class^="aftership-reviews-widget-v2_cardContainer"] div:nth-child(2) > div {
    font-size: 13px !important;
    font-weight: 500 !important;
  }

  [class^="aftership-reviews-widget-v2_badgeContainer"] svg path {
    fill: var(--color-yellow) !important;
  }

  [class^="aftership-reviews-widget-v2_helpfulWrapper"],
  [class^="aftership-reviews-widget-v2_productInfoContainer"] {
    margin-block-start: -16px !important;
  }

  [class^="aftership-reviews-widget-v2_cardContainer"] > div:nth-child(4) div {
    font-size: 13px !important;
  }

  [class^="aftership-reviews-widget-v2_readMore"] {
    color: inherit !important;
    font-size: inherit !important;
  }

  [class^="aftership-reviews-widget-v2_customizedQuestionsContainer"],
  [class^="aftership-reviews-widget-v2_helpfulWrapper"],
  [class^="aftership-reviews-widget-v2_productInfoContainer"] {
    display: none !important;
    margin-block-start: 0 !important;
  }

  div[style*="margin-top"] {
    margin-top: 0 !important;
  }

  [class^="aftership-reviews-widget-v2_reviewTitle"] {
    color: var(--color-text-primary) !important;
    font-family: Geograph, Helvetica, Arial, sans-serif !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    letter-spacing: 0.5px !important;
    line-height: 140% !important;
    margin: 16px 0 !important;
    text-transform: uppercase !important;
  }

  [class^="aftership-reviews-widget-v2_pagination"] {
    justify-content: center !important;
    margin-top: 40px !important;
  }

  [class^="aftership-reviews-widget-v2_pagination"] div {
    font-family: Geograph, Helvetica, Arial, sans-serif !important;
    font-size: 12px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    letter-spacing: 0.25px !important;
    line-height: 140% !important;
    padding: 16px !important;
  }

  .solid-select-option {
    font-size: 13px !important;
  }

  .solid-select-option[data-focused="true"] {
    font-weight: 500 !important;
  }

  @media (max-width: 1024px) {
    #widgetHeaderContainer {
      flex-direction: column !important;
      gap: 40px !important;
      margin-inline: -20px !important;
      margin-bottom: 20px !important;
    }

    #writeGroupButton {
      justify-content: flex-start !important;
    }

    #writeReviewButton {
      gap: 40px !important;
    }

    #overallRatingContainer {
      display: grid !important;
      grid-template-columns: 1fr 1fr !important;
      grid-template-rows: auto auto !important;
    }

    [class^="aftership-reviews-widget-v2_title"] {
      grid-column: 1 / 3 !important;
      margin-bottom: 16px !important;
    }

    [class^="aftership-reviews-widget-v2_rate--"] {
      grid-column: 1 !important;
      margin-bottom: 0 !important;
    }

    #overallRatingContainer > div:nth-child(3) {
      align-items: center !important;
      grid-column: 2 !important;
    }

    [class^="aftership-reviews-widget-v2_ratingReviews"] {
      width: 100% !important;
    }

    [class^="aftership-reviews-widget-v2_ratingReviewsContainer"],
    [class^="aftership-reviews-widget-v2_ratersContainer"] {
      margin-top: 40px !important;
    }

    [class^="aftership-reviews-widget-v2_reviewTitle"],
    [class^="aftership-reviews-widget-v2_cardContainer"] > div:nth-child(4) div {
      font-size: 12px !important;
    }

    [class^="aftership-reviews-widget-v2_filterSortContainer"] {
      flex-direction: row !important;
    }

    [class^="aftership-reviews-widget-v2_cardContainer"] {
      margin-top: 40px !important;
    }
  }
`;

const AFTERSHIP_MODAL_STYLES = `
  #writeReviewCardTitle {
    color: #212b36 !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    margin-bottom: 8px !important;
  }

  [class^="aftership-reviews-widget-v2_cardContainer"] {
    gap: 8px !important;
  }

  [class^="aftership-reviews-widget-v2_multi"],
  [class^="aftership-reviews-widget-v2_label"] {
    font-size: 13px !important;
    line-height: 140% !important;
  }

  [class*="aftership-reviews-widget-v2_circle"][style*="background: rgb(24, 102, 235)"] {
    background-color: #111111 !important;
  }

  [class^="aftership-reviews-widget-v2_primaryButton"] {
    border-radius: 0 !important;
    padding: 16px 15px !important;
  }

  [class^="aftership-reviews-widget-v2_primaryButton"] div:nth-child(2) {
    font-family: Geograph, Helvetica, Arial, sans-serif !important;
    font-size: 11px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    letter-spacing: 2px !important;
    line-height: 140% !important;
    text-transform: uppercase !important;
  }
`;

class LyleReviewsSection extends HTMLElement {
  #abortController = null;
  #aftershipModalObserver = null;
  #aftershipModalInterval = null;
  #aftershipWidgetObserver = null;
  #aftershipWidgetInterval = null;
  #contentObserver = null;
  #reviewsObserver = null;
  #leftArrowMarkup = "";
  #rightArrowMarkup = "";

  connectedCallback() {
    this.#leftArrowMarkup =
      this.querySelector("[data-reviews-arrow-left]")?.innerHTML.trim() ?? "";
    this.#rightArrowMarkup =
      this.querySelector("[data-reviews-arrow-right]")?.innerHTML.trim() ?? "";

    this.#abortController = new AbortController();
    const signal = this.#abortController.signal;

    document.addEventListener("lyle:product-updated", this.#handleProductUpdated, {
      signal,
    });

    this.#observeSectionContent();
    this.#customizeAftershipWidget();
    this.#customizeAftershipModal();
    this.#observeAftershipModal();
    this.#observeAftershipWidget();
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    window.clearInterval(this.#aftershipWidgetInterval);
    window.clearInterval(this.#aftershipModalInterval);
    this.#aftershipModalObserver?.disconnect();
    this.#aftershipWidgetObserver?.disconnect();
    this.#contentObserver?.disconnect();
    this.#reviewsObserver?.disconnect();
  }

  #observeSectionContent() {
    this.#contentObserver?.disconnect();

    this.#contentObserver = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type !== "childList") {
          continue;
        }

        if (mutation.addedNodes.length === 0) {
          continue;
        }

        this.#contentObserver?.disconnect();
        this.#sectionLoaded();
        return;
      }
    });

    this.#contentObserver.observe(this, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    if (this.querySelector(".spr-summary-actions-newreview")) {
      this.#contentObserver.disconnect();
      this.#sectionLoaded();
    }
  }

  #observeReviewsPagination() {
    const reviewsNode = this.querySelector(".spr-reviews");

    if (!reviewsNode) {
      return;
    }

    this.#reviewsObserver?.disconnect();

    this.#reviewsObserver = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (mutation.type !== "childList") {
          continue;
        }

        this.#addPaginationArrows();
        this.#reviewsObserver?.disconnect();
        this.#observeReviewsPagination();
        return;
      }
    });

    this.#reviewsObserver.observe(reviewsNode, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  #sectionLoaded() {
    this.#addButtonClasses();
    this.#addIconToButton();
    this.#addPaginationArrows();
    this.#observeReviewsPagination();
  }

  #addButtonClasses() {
    const newReviewButton = this.querySelector(".spr-summary-actions-newreview");

    if (!newReviewButton) {
      return;
    }

    newReviewButton.classList.add("button");
  }

  #addIconToButton() {
    const newReviewButton = this.querySelector(".spr-summary-actions-newreview");

    if (!newReviewButton || !this.#rightArrowMarkup) {
      return;
    }

    if (newReviewButton.querySelector(".icon__arrow--right")) {
      return;
    }

    newReviewButton.insertAdjacentHTML("beforeend", this.#rightArrowMarkup);
  }

  #addPaginationArrows() {
    const previous = this.querySelector(".spr-pagination-prev > a");
    const next = this.querySelector(".spr-pagination-next > a");

    if (previous && this.#leftArrowMarkup) {
      previous.innerHTML = this.#leftArrowMarkup;
    }

    if (next && this.#rightArrowMarkup) {
      next.innerHTML = this.#rightArrowMarkup;
    }
  }

  #customizeAftershipWidget() {
    this.#aftershipWidgetInterval = this.#injectShadowStylesWithRetry({
      selector: "#am-reviews-carousel-shadow-container-production",
      styleId: "aftership-custom",
      styles: AFTERSHIP_WIDGET_STYLES,
    });
  }

  #observeAftershipWidget() {
    this.#aftershipWidgetObserver?.disconnect();

    this.#aftershipWidgetObserver = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) {
            continue;
          }

          if (
            node.id === "am-reviews-carousel-shadow-container-production" ||
            node.querySelector?.("#am-reviews-carousel-shadow-container-production")
          ) {
            this.#customizeAftershipWidget();
            return;
          }
        }
      }
    });

    this.#aftershipWidgetObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  #customizeAftershipModal() {
    this.#aftershipModalInterval = this.#injectShadowStylesWithRetry({
      selector: "#writeReviewCard",
      styleId: "aftership-modal-custom",
      styles: AFTERSHIP_MODAL_STYLES,
    });
  }

  #observeAftershipModal() {
    this.#aftershipModalObserver?.disconnect();

    this.#aftershipModalObserver = new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) {
            continue;
          }

          if (node.id === "writeReviewCard" || node.querySelector?.("#writeReviewCard")) {
            this.#customizeAftershipModal();
            return;
          }
        }
      }
    });

    this.#aftershipModalObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  #injectShadowStylesWithRetry({ selector, styleId, styles }) {
    let attempts = 0;
    const maxAttempts = 40;

    const tryInjectStyles = () => {
      const host = document.querySelector(selector);
      const shadow = host?.shadowRoot;

      if (!shadow) {
        return false;
      }

      if (shadow.querySelector(`style[data-${styleId}]`)) {
        return true;
      }

      const style = document.createElement("style");
      style.setAttribute(`data-${styleId}`, "true");
      style.textContent = styles;
      shadow.appendChild(style);

      return true;
    };

    if (tryInjectStyles()) {
      return null;
    }

    const interval = window.setInterval(() => {
      attempts += 1;

      if (tryInjectStyles() || attempts >= maxAttempts) {
        window.clearInterval(interval);
      }
    }, 250);

    return interval;
  }

  #handleProductUpdated = (event) => {
    const reviews = this.querySelector("#shopify-product-reviews");
    const productId = event.detail?.response?.id;

    if (!reviews || productId == null) {
      return;
    }

    if (Number.parseInt(reviews.dataset.id, 10) === Number(productId)) {
      return;
    }

    reviews.dataset.id = String(productId);

    const productReviewsScript = [...document.scripts].find((script) =>
      script.src.includes("productreviews"),
    );

    if (!productReviewsScript?.src) {
      return;
    }

    this.#reloadReviewsScript(productReviewsScript.src);
  };

  #reloadReviewsScript(src) {
    const head = document.head;
    const existingScripts = [...head.querySelectorAll("script")].filter(
      (script) => script.src === src,
    );

    for (const script of existingScripts) {
      script.remove();
    }

    const script = document.createElement("script");
    script.src = src;
    head.appendChild(script);

    this.#observeSectionContent();
    this.#customizeAftershipWidget();
  }
}

if (!customElements.get("lyle-reviews-section")) {
  customElements.define("lyle-reviews-section", LyleReviewsSection);
}

const initializeAftershipReviewStyles = () => {
  const injectShadowStyles = ({ selector, styleId, styles }) => {
    const host = document.querySelector(selector);
    const shadow = host?.shadowRoot;

    if (!shadow) {
      return false;
    }

    if (shadow.querySelector(`style[data-${styleId}]`)) {
      return true;
    }

    const style = document.createElement("style");
    style.setAttribute(`data-${styleId}`, "true");
    style.textContent = styles;
    shadow.appendChild(style);

    return true;
  };

  const injectWidgetStyles = () =>
    injectShadowStyles({
      selector: "#am-reviews-carousel-shadow-container-production",
      styleId: "aftership-custom",
      styles: AFTERSHIP_WIDGET_STYLES,
    });

  const injectModalStyles = () =>
    injectShadowStyles({
      selector: "#writeReviewCard",
      styleId: "aftership-modal-custom",
      styles: AFTERSHIP_MODAL_STYLES,
    });

  injectWidgetStyles();
  injectModalStyles();

  const observer = new MutationObserver((mutationList) => {
    for (const mutation of mutationList) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) {
          continue;
        }

        if (
          node.id === "am-reviews-carousel-shadow-container-production" ||
          node.querySelector?.("#am-reviews-carousel-shadow-container-production")
        ) {
          injectWidgetStyles();
        }

        if (node.id === "writeReviewCard" || node.querySelector?.("#writeReviewCard")) {
          injectModalStyles();
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.addEventListener("lyle:product-updated", injectWidgetStyles);
};

if (!window.__lyleAftershipReviewStylesInitialized) {
  window.__lyleAftershipReviewStylesInitialized = true;
  initializeAftershipReviewStyles();
}
